class RegisterService {
    register = async (model, returnUrl, provider) => {
        let response = await fetch('/Register/Register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                ...model,
                howDidYouHearAboutUs: !model.howDidYouHearAboutUs ? - 1 : model.howDidYouHearAboutUs,
                termsOfUse: '',
                returnUrl,
                provider
            })
        });

        return response.json();
    };

    isValidEmailNewUser = async (email, returnUrl) => {
        let response = await fetch('/Register/ValidEmailNewUser', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                email,
                returnUrl
            })
        });

        return response.json();
    };

    getRegisterSettings = async (returnUrl) => {
        let response = await fetch('/Register/RegisterSettings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify({
                returnUrl: returnUrl
            })
        });
        return response.json();
    };
};

const registerService = new RegisterService();

export default registerService;